module.exports = __webpack_public_path__ + "img/icon-wip.c6806094.png";